import { HttpClient } from '@angular/common/http'
import { NgModule, Type } from '@angular/core'
import { SharedModule } from '@shared'
import { MarkdownModule } from 'ngx-markdown'

import { SupportAiComponent } from './ai/ai.component'
import { SupportGuidComponent } from './guid/guid.component'
import { SupportOperationComponent } from './operation/operation.component'
import { SupportQuestionComponent } from './question/question.component'
import { SupportRoutingModule } from './support-routing.module'
import { SupportWelcomeComponent } from './welcome/welcome.component'

const COMPONENTS: Array<Type<void>> = [
  SupportGuidComponent,
  SupportQuestionComponent,
  SupportOperationComponent,
  SupportWelcomeComponent,
  SupportAiComponent,
]

@NgModule({
  imports: [SharedModule, SupportRoutingModule, MarkdownModule.forRoot({ loader: HttpClient })],
  exports: [SupportAiComponent],
  declarations: COMPONENTS,
})
export class SupportModule {}
